import { ReactElement } from "react";
import SideBar from "../Sidebar/SideBar";

import "./Layout.scss";

export default function Layout(props: {
  selectedIndex: number;
  children: ReactElement;
}) {
  return (
    <div className="layout-container">
      <SideBar selectedIndex={props.selectedIndex} />
      <div className="text-container">
        {props.children}     
      </div>
    </div>
  );
}
